import styled from "styled-components"

export const Title = styled.div`
	font-family: 'Quicksand', sans-serif;
	font-weight: bold;
`
